module.exports = __webpack_public_path__ + "img/quixel.213bf606.png";